import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {}

const CheckMarkIcon = ({ ...props }: any) => (
  <svg width="13" height="10" viewBox="0 0 13 10" fill="none">
    <path
      d="M1.375 4.875L4.875 8.625L11.875 1.125"
      stroke="var(--color-blue)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const CalenderIcon = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
  >
    <path
      d="M5.33398 1.33398V3.33398"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M10.666 1.33398V3.33398"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M2.33398 6.06055H13.6673"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M14 5.66732V11.334C14 13.334 13 14.6673 10.6667 14.6673H5.33333C3 14.6673 2 13.334 2 11.334V5.66732C2 3.66732 3 2.33398 5.33333 2.33398H10.6667C13 2.33398 14 3.66732 14 5.66732Z"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M10.4625 9.13411H10.4685"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M10.4625 11.1341H10.4685"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M7.99764 9.13411H8.00363"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M7.99764 11.1341H8.00363"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M5.52889 9.13411H5.53488"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M5.52889 11.1341H5.53488"
      stroke="var(--color-icon-bright)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const DownArrow = ({ className }: { className?: string }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <g id="vuesax/outline/arrow-down">
      <g id="arrow-down">
        <path
          id="Vector"
          d="M7.00038 9.80036C6.59204 9.80036 6.18371 9.64286 5.87454 9.3337L2.07121 5.53036C1.90204 5.3612 1.90204 5.0812 2.07121 4.91203C2.24038 4.74286 2.52038 4.74286 2.68954 4.91203L6.49288 8.71536C6.77288 8.99536 7.22788 8.99536 7.50788 8.71536L11.3112 4.91203C11.4804 4.74286 11.7604 4.74286 11.9295 4.91203C12.0987 5.0812 12.0987 5.3612 11.9295 5.53036L8.12621 9.3337C7.81705 9.64286 7.40871 9.80036 7.00038 9.80036Z"
          fill="var(--color-icon-bright)"
        ></path>
      </g>
    </g>
  </svg>
);

export const UpArrow = ({ className }: { className?: string }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <g id="vuesax/outline/arrow-up">
      <g id="arrow-up">
        <path
          id="Vector"
          d="M11.6204 9.21688C11.5095 9.21688 11.3987 9.17604 11.3112 9.08854L7.50788 5.28521C7.22788 5.00521 6.77288 5.00521 6.49288 5.28521L2.68954 9.08854C2.52038 9.25771 2.24038 9.25771 2.07121 9.08854C1.90204 8.91938 1.90204 8.63938 2.07121 8.47021L5.87454 4.66688C6.49288 4.04854 7.50205 4.04854 8.12621 4.66688L11.9295 8.47021C12.0987 8.63938 12.0987 8.91938 11.9295 9.08854C11.842 9.17021 11.7312 9.21688 11.6204 9.21688Z"
          fill="var(--color-icon-bright)"
        ></path>
      </g>
    </g>
  </svg>
);

export const EmailIcon = ({
  fillColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="81" height="80" viewBox="0 0 81 80" fill="none">
    <path
      opacity="0.4"
      d="M57.1665 68.3307H23.8332C13.8332 68.3307 7.1665 63.3307 7.1665 51.6641V28.3307C7.1665 16.6641 13.8332 11.6641 23.8332 11.6641H57.1665C67.1665 11.6641 73.8332 16.6641 73.8332 28.3307V51.6641C73.8332 63.3307 67.1665 68.3307 57.1665 68.3307Z"
      fill={fillColor}
    />
    <path
      d="M40.4999 42.9038C37.6999 42.9038 34.8666 42.0371 32.6999 40.2705L22.2666 31.9371C21.1999 31.0705 20.9999 29.5038 21.8666 28.4371C22.7333 27.3705 24.2999 27.1705 25.3666 28.0372L35.7999 36.3705C38.3332 38.4038 42.6332 38.4038 45.1666 36.3705L55.5999 28.0372C56.6666 27.1705 58.2666 27.3371 59.0999 28.4371C59.9666 29.5038 59.7999 31.1038 58.6999 31.9371L48.2666 40.2705C46.1332 42.0371 43.2999 42.9038 40.4999 42.9038Z"
      fill={fillColor}
    />
  </svg>
);

export const ChatIcon = ({
  fillColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="81" height="80" viewBox="0 0 81 80" fill="none">
    <path
      opacity="0.4"
      d="M7.1665 43.2307V23.2974C7.1665 14.0974 14.6332 6.66406 23.8332 6.66406H57.1665C66.3665 6.66406 73.8332 14.0974 73.8332 23.2974V46.5641C73.8332 55.7307 66.3665 63.1641 57.1665 63.1641H52.1665C51.1332 63.1641 50.1332 63.6641 49.4998 64.4974L44.4998 71.1307C42.2998 74.0641 38.6998 74.0641 36.4998 71.1307L31.4998 64.4974C30.9665 63.7641 29.7665 63.1641 28.8332 63.1641H23.8332C14.6332 63.1641 7.1665 55.7307 7.1665 46.5641V43.2307Z"
      fill={fillColor}
    />
    <path
      d="M40.4998 40.0026C38.6332 40.0026 37.1665 38.5026 37.1665 36.6693C37.1665 34.8359 38.6665 33.3359 40.4998 33.3359C42.3332 33.3359 43.8332 34.8359 43.8332 36.6693C43.8332 38.5026 42.3665 40.0026 40.4998 40.0026Z"
      fill={fillColor}
    />
    <path
      d="M53.8333 40.0026C51.9667 40.0026 50.5 38.5026 50.5 36.6693C50.5 34.8359 52 33.3359 53.8333 33.3359C55.6667 33.3359 57.1667 34.8359 57.1667 36.6693C57.1667 38.5026 55.7 40.0026 53.8333 40.0026Z"
      fill={fillColor}
    />
    <path
      d="M27.1668 40.0026C25.3002 40.0026 23.8335 38.5026 23.8335 36.6693C23.8335 34.8359 25.3335 33.3359 27.1668 33.3359C29.0002 33.3359 30.5002 34.8359 30.5002 36.6693C30.5002 38.5026 29.0335 40.0026 27.1668 40.0026Z"
      fill={fillColor}
    />
  </svg>
);

export const MessageChat = ({
  fillColor = "var(--color-icon-bright)",
  className,
}: {
  fillColor?: string;
  className?: string;
}) => (
  <svg
    width="81"
    height="81"
    viewBox="0 0 81 81"
    fill="none"
    className={className}
  >
    <path
      opacity="0.4"
      d="M62.0668 56.5974L63.3668 67.1307C63.7001 69.8974 60.7335 71.8306 58.3668 70.3973L44.4001 62.0973C42.8668 62.0973 41.3668 61.9974 39.9002 61.7974C42.3668 58.8974 43.8335 55.2307 43.8335 51.264C43.8335 41.7973 35.6335 34.1308 25.5001 34.1308C21.6335 34.1308 18.0668 35.2307 15.1002 37.1641C15.0002 36.3307 14.9668 35.4974 14.9668 34.6307C14.9668 19.464 28.1335 7.16406 44.4001 7.16406C60.6668 7.16406 73.8335 19.464 73.8335 34.6307C73.8335 43.6307 69.2001 51.5975 62.0668 56.5974Z"
      fill={fillColor}
    />
    <path
      d="M43.8332 51.266C43.8332 55.2327 42.3665 58.8994 39.8999 61.7994C36.5999 65.7994 31.3665 68.366 25.4998 68.366L16.7998 73.5326C15.3332 74.4326 13.4665 73.1994 13.6665 71.4994L14.4998 64.9328C10.0332 61.8328 7.1665 56.866 7.1665 51.266C7.1665 45.3993 10.2999 40.2327 15.0999 37.1661C18.0665 35.2327 21.6332 34.1328 25.4998 34.1328C35.6332 34.1328 43.8332 41.7993 43.8332 51.266Z"
      fill={fillColor}
    />
  </svg>
);

export const SuccessIcon = ({
  fillColor = "var(--color-green)",
  className,
}: {
  fillColor?: string;
  className?: string;
}) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    className={className}
  >
    <path
      d="M49.9997 94.7943C25.2913 94.7943 5.20801 74.7109 5.20801 50.0026C5.20801 25.2943 25.2913 5.21094 49.9997 5.21094C74.708 5.21094 94.7913 25.2943 94.7913 50.0026C94.7913 74.7109 74.708 94.7943 49.9997 94.7943ZM49.9997 11.4609C28.7497 11.4609 11.458 28.7526 11.458 50.0026C11.458 71.2526 28.7497 88.5443 49.9997 88.5443C71.2497 88.5443 88.5413 71.2526 88.5413 50.0026C88.5413 28.7526 71.2497 11.4609 49.9997 11.4609Z"
      fill={fillColor}
    />
    <path
      d="M44.083 64.9193C43.2497 64.9193 42.458 64.5859 41.8747 64.0026L30.083 52.2109C28.8747 51.0026 28.8747 49.0026 30.083 47.7943C31.2913 46.5859 33.2913 46.5859 34.4997 47.7943L44.083 57.3776L65.4997 35.9609C66.708 34.7526 68.708 34.7526 69.9163 35.9609C71.1247 37.1693 71.1247 39.1693 69.9163 40.3776L46.2913 64.0026C45.708 64.5859 44.9163 64.9193 44.083 64.9193Z"
      fill={fillColor}
    />
  </svg>
);

export const DisclosureCloseIcon = ({
  fillColor = "var(--color-icon-bright)",
}: {
  fillColor?: string;
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M8.88487 12.8752L8.88397 12.8743L5.67397 9.66426C5.30803 9.29832 5.56718 8.67781 6.08042 8.67781L12.3104 8.67781H17.9204C18.4286 8.67781 18.6893 9.30182 18.3269 9.66426L13.1469 14.8443C12.5123 15.4789 11.4791 15.479 10.8444 14.8447C10.8442 14.8445 10.8441 14.8444 10.844 14.8443L8.88487 12.8752Z"
      fill={fillColor}
      stroke={fillColor}
    />
  </svg>
);

export const DisclosureOpenIcon = ({
  fillColor = "var(--color-icon-obscure)",
}: {
  fillColor?: string;
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M15.1151 11.1248L15.116 11.1257L18.326 14.3357C18.692 14.7017 18.4328 15.3222 17.9196 15.3222H11.6896H6.07958C5.57139 15.3222 5.31069 14.6982 5.67314 14.3357L10.8531 9.15574C11.4877 8.52114 12.5209 8.521 13.1556 9.15534C13.1558 9.15547 13.1559 9.15561 13.156 9.15574L15.1151 11.1248Z"
      fill={fillColor}
      stroke={fillColor}
    />
  </svg>
);

export const OfferIcon = ({
  fillColor = "var(--color-icon-bright)",
  className,
}: {
  fillColor?: string;
  className?: string;
}) => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    className={className}
  >
    <path
      d="M47.4686 27.802C46.8973 26.8059 46.3212 25.8098 45.7499 24.8088C45.4667 24.2961 45.4667 23.6955 45.7499 23.1828C45.8231 23.051 45.8964 22.924 45.9696 22.7971C46.3261 22.1721 46.6874 21.552 47.0438 20.927C47.288 20.5022 47.537 20.0774 47.7811 19.6477C48.3427 18.6418 48.1962 17.3527 47.3759 16.5275C46.9999 16.1516 46.4774 15.9074 46.0233 15.6438C45.369 15.2678 44.7147 14.8918 44.0604 14.5158C43.6259 14.2668 43.079 14.0324 42.7811 13.6174C42.4247 13.1193 42.4686 12.5529 42.4686 11.9817V9.74044C42.4686 9.22775 42.5077 8.69552 42.4345 8.18771C42.2636 7.02071 41.2675 6.15646 40.1151 6.03439C39.6415 5.98556 39.1434 6.02462 38.6649 6.02462H36.4384C35.8573 6.02462 35.2909 6.0588 34.8026 5.66329C34.412 5.34591 34.1776 4.79904 33.9286 4.36935C33.5526 3.71505 33.1766 3.06075 32.8007 2.41134C32.5272 1.93771 32.2782 1.40548 31.8632 1.03927C31.0184 0.292199 29.8075 0.175011 28.8309 0.721886C27.7616 1.32247 26.702 1.94747 25.6425 2.55782C25.5058 2.63595 25.3739 2.71896 25.2372 2.78732C24.7489 3.04611 24.1581 3.01193 23.6796 2.74825C23.2499 2.509 22.83 2.25997 22.4003 2.01095C21.7753 1.6545 21.1552 1.29318 20.5302 0.931847C19.91 0.575402 19.2899 0.292199 18.5477 0.384972C17.6444 0.497277 16.9706 1.03927 16.5214 1.81075C16.1991 2.36739 15.8768 2.92892 15.5546 3.48556C15.247 4.02267 14.9345 4.55978 14.6268 5.09689C14.2948 5.67794 13.7675 6.01485 13.0888 6.01485C11.8388 6.01974 10.5888 6.01485 9.33388 6.01485C8.52333 6.01485 7.74696 6.23458 7.18544 6.85958C6.78993 7.29904 6.56532 7.84591 6.51649 8.43185C6.50185 8.59298 6.51161 8.759 6.51161 8.92013C6.51161 10.1555 6.52626 11.3908 6.51161 12.6262C6.50673 13.3293 6.11122 13.8225 5.52528 14.1594C4.96376 14.4817 4.40224 14.8088 3.84071 15.1311C3.30849 15.4387 2.77626 15.7463 2.24403 16.0539C1.4286 16.5227 0.886612 17.3332 0.862198 18.2902C0.842667 18.9836 1.15517 19.5451 1.4872 20.1213C1.85829 20.761 2.2245 21.4055 2.5956 22.05C2.83485 22.4651 3.11806 22.8801 3.31825 23.3147C3.53798 23.7932 3.49403 24.3498 3.24013 24.8039C3.162 24.9455 3.07899 25.0871 2.99599 25.2238C2.40028 26.259 1.78993 27.2893 1.20399 28.3293C0.627823 29.3596 0.793839 30.7072 1.68251 31.5129C2.07314 31.8693 2.58583 32.1086 3.03993 32.3723C3.69423 32.7483 4.34364 33.1242 4.99794 33.5002C5.44716 33.759 5.97938 33.9885 6.26259 34.4475C6.57509 34.9455 6.51649 35.5119 6.51649 36.0734V38.3244C6.51649 38.8371 6.47255 39.3791 6.56532 39.8869C6.78017 41.049 7.83485 41.8986 8.99696 41.9524C9.46571 41.9719 9.93446 41.9524 10.4032 41.9524H12.5907C13.2059 41.9524 13.7919 41.9426 14.2753 42.4065C14.6268 42.7434 14.8466 43.2658 15.0858 43.6809C15.4569 44.3254 15.828 44.9748 16.204 45.6193C16.4921 46.1174 16.7509 46.6545 17.2099 47.0207C18.0595 47.6994 19.2118 47.7824 20.1591 47.2453C20.6278 46.9817 21.0917 46.7082 21.5556 46.4397C22.1659 46.0881 22.7763 45.7365 23.3866 45.385C23.5331 45.302 23.6747 45.2043 23.8309 45.1359C24.3095 44.926 24.8563 44.9699 25.3104 45.2238C26.3798 45.8244 27.4393 46.4494 28.4989 47.0647C28.621 47.133 28.7382 47.2063 28.8602 47.2746C29.4022 47.5725 30.0077 47.6652 30.6132 47.5578C31.4481 47.4113 32.0536 46.84 32.4638 46.132C33.0936 45.0383 33.7235 43.9397 34.3583 42.8459C34.6952 42.2649 35.2323 41.9524 35.9013 41.9524C36.5018 41.9524 37.1024 41.9524 37.703 41.9524H39.6806C40.5057 41.9524 41.3016 41.6984 41.8436 41.0393C42.2245 40.5754 42.4442 40.009 42.454 39.4035C42.4589 39.2668 42.454 39.1252 42.454 38.9885V36.8547C42.454 36.3469 42.4491 35.8391 42.454 35.3313C42.4589 34.8772 42.6298 34.4572 42.9569 34.1447C43.1083 33.9983 43.2889 33.8957 43.4696 33.7932C44.5634 33.1633 45.6571 32.5383 46.746 31.9035C47.5761 31.425 48.1278 30.5608 48.1083 29.5891C48.1132 28.9152 47.7958 28.3733 47.4686 27.802ZM14.4413 17.133C14.6513 16.2981 15.1444 15.468 15.8085 14.9162C16.58 14.2766 17.4345 13.9201 18.4306 13.8176C20.1688 13.6418 21.995 14.6916 22.7323 16.2736C23.162 17.1867 23.2694 18.1193 23.1083 19.1106C22.9765 19.9455 22.5224 20.7317 21.9462 21.342C21.9315 21.3567 21.912 21.3762 21.8974 21.3908C21.8778 21.4104 21.8534 21.4348 21.8339 21.4543C20.3739 22.8264 18.035 23.1291 16.3407 21.9817C14.7587 20.9123 13.9774 19.0031 14.4413 17.133ZM23.0497 27.4602C21.8436 28.6662 20.6376 29.8723 19.4315 31.0783C18.9286 31.5813 18.4257 32.0842 17.9227 32.5871C17.3612 33.1486 16.4774 33.1096 15.911 32.5871C15.3446 32.0647 15.3837 31.1027 15.911 30.5754C15.9208 30.5656 15.9306 30.5559 15.9354 30.551C16.536 29.926 17.1659 29.3205 17.7811 28.7053C19.0458 27.4406 20.3056 26.1809 21.5702 24.9162C23.0302 23.4563 24.4901 21.9963 25.9501 20.5363C27.1561 19.3303 28.3622 18.1242 29.5682 16.9182C30.0712 16.4152 30.5741 15.9123 31.077 15.4094C31.6386 14.8479 32.5224 14.8869 33.0888 15.4094C33.6552 15.9318 33.6161 16.8938 33.0888 17.4211C33.079 17.4309 33.0692 17.4406 33.0643 17.4455C32.4638 18.0705 31.8339 18.676 31.2186 19.2912C29.954 20.5559 28.6942 21.8156 27.4296 23.0803C25.9696 24.5402 24.5097 26.0002 23.0497 27.4602ZM34.6171 30.6047C34.4852 31.4397 34.0311 32.2307 33.455 32.8361C33.4403 32.8508 33.4208 32.8703 33.4061 32.885C33.3866 32.9045 33.3622 32.9289 33.3427 32.9484C31.8827 34.3205 29.5438 34.6233 27.8495 33.4807C26.2675 32.4113 25.4862 30.4973 25.955 28.6272C26.1649 27.7922 26.6581 26.9621 27.3222 26.4104C28.0936 25.7658 28.9481 25.4094 29.9442 25.3117C31.6825 25.136 33.5087 26.1906 34.246 27.7678C34.6659 28.6809 34.7733 29.6086 34.6171 30.6047Z"
      fill={fillColor}
    />
  </svg>
);

export const BudgetCalculatorIcon = ({
  fillColor = "var(--color-icon-bright)",
  className,
}: {
  fillColor?: string;
  className?: string;
}) => (
  <svg
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    className={className}
  >
    <path
      d="M6.80867 2.03125C6.65242 2.08984 6.41805 2.24609 6.30086 2.38281C5.71492 2.92969 5.73445 1.62109 5.73445 22.8125C5.73445 41.2695 5.75398 42.4414 5.92976 42.8125C6.02742 43.0078 6.28133 43.3008 6.47664 43.418L6.84773 43.6719H14.8165C19.211 43.6719 22.8048 43.6523 22.8048 43.6133C22.8048 43.5742 22.668 43.2812 22.4923 42.9297C21.8282 41.6016 21.2032 39.375 21.2032 38.3008V37.9102L20.9493 38.3398C20.2852 39.4922 18.7618 39.5703 18.0782 38.4766C17.7657 37.9688 17.8243 37.0117 18.2149 36.6016C18.9962 35.7617 20.3048 35.8398 20.8712 36.7773L21.0665 37.1094L21.1446 36.2695C21.1837 35.8008 21.3009 34.9414 21.418 34.3555C22.4923 29.1602 26.9259 24.8828 32.0821 24.1016C32.5509 24.0234 33.0001 23.9453 33.0782 23.9258C33.1759 23.8867 33.2149 21.7969 33.1759 13.4375C33.1368 3.06641 33.1368 2.96875 32.922 2.67578C32.8048 2.51953 32.5704 2.28516 32.4141 2.16797C32.1212 1.93359 32.0626 1.93359 19.6016 1.91406C11.4376 1.95312 6.98445 1.97266 6.80867 2.03125ZM28.2735 10.1758V13.4961H19.4845H10.6759V10.1758V6.85547H19.4845H28.293V10.1758H28.2735ZM13.2345 22.0117C14.0352 22.5 14.1915 23.6719 13.5665 24.4141C13.1563 24.8633 12.7266 25.0391 12.1407 24.9805C10.1095 24.7461 10.2657 21.7773 12.3165 21.7773C12.668 21.7773 12.9805 21.8555 13.2345 22.0117ZM20.3048 21.9922C20.793 22.2852 21.086 22.8125 21.086 23.3789C21.086 25.0195 18.9571 25.6055 18.0782 24.2188C17.7462 23.6914 17.8243 22.7539 18.254 22.3047C18.4298 22.1289 18.6641 21.9336 18.7813 21.8945C19.172 21.7188 19.9532 21.7578 20.3048 21.9922ZM27.5118 21.9922C27.8829 22.2266 28.2735 22.9297 28.293 23.3789C28.293 23.75 27.9024 24.4922 27.5704 24.7266C27.1602 25.0195 26.3009 25.0781 25.8126 24.8047C25.3829 24.5703 24.9532 23.8477 24.9532 23.3398C24.9532 22.8711 25.2657 22.3047 25.6954 22.0117C26.1641 21.6992 27.004 21.6797 27.5118 21.9922ZM12.9805 29.0039C13.8009 29.3555 14.1915 30.332 13.8204 31.1523C13.3321 32.2656 11.9259 32.5 11.1251 31.6016C10.5782 30.9766 10.5587 30.1367 11.086 29.4922C11.5743 28.9062 12.2774 28.7109 12.9805 29.0039ZM20.2266 29.1016C20.8516 29.4141 21.1251 29.9219 21.047 30.6445C21.0079 31.3086 20.754 31.6797 20.1485 31.9727C19.6212 32.2461 19.3282 32.2461 18.7618 31.9922C17.5704 31.4453 17.5313 29.6875 18.7227 29.082C19.211 28.7891 19.6407 28.8086 20.2266 29.1016ZM13.0977 36.2109C13.5274 36.4062 13.8595 36.9141 13.9376 37.4805C13.9962 37.8125 13.9571 38.0078 13.7618 38.3789C13.1368 39.5508 11.4962 39.5508 10.8712 38.3984C10.129 36.9922 11.6329 35.5273 13.0977 36.2109Z"
      fill={fillColor}
    />
    <path
      d="M33.2928 26.1916C29.1522 26.5432 25.4998 29.3557 24.0155 33.2619C23.0584 35.801 23.117 38.7893 24.1522 41.3283C25.4217 44.4533 28.1952 46.8557 31.6131 47.7737C32.8436 48.1057 35.1287 48.1643 36.4373 47.8908C41.2616 46.8948 44.7772 42.969 45.2264 38.1448C45.3241 36.9143 45.2069 35.3518 44.9139 34.2776C44.6209 33.2229 43.8787 31.6408 43.2537 30.7815C42.6483 29.9416 41.4959 28.7893 40.6561 28.1838C39.2889 27.2073 37.16 26.3869 35.6756 26.2698C35.285 26.2307 34.7967 26.1916 34.6014 26.1721C34.4061 26.1135 33.8202 26.133 33.2928 26.1916ZM34.7381 28.4377C35.1678 28.6721 35.3436 28.9846 35.3436 29.5705C35.3436 29.9807 35.3827 30.1369 35.4998 30.1369C35.578 30.1369 35.9881 30.3127 36.3983 30.508C37.7459 31.1916 38.6639 32.5002 38.6639 33.7307C38.6639 34.7658 37.5116 35.2737 36.828 34.5315C36.6717 34.3557 36.5155 34.0432 36.4764 33.7893C36.3983 33.2424 35.8709 32.6369 35.285 32.3635C34.6991 32.0901 33.6053 32.0901 33.0194 32.383C32.3553 32.676 32.1014 33.1252 32.1405 33.9651C32.1795 34.5315 32.2381 34.6877 32.492 34.9807C32.8631 35.3713 33.742 35.801 34.9139 36.1526C36.6327 36.6604 37.6873 37.4221 38.2537 38.594C38.5662 39.258 38.6053 39.3948 38.6053 40.3323C38.6053 41.2893 38.5858 41.3869 38.2342 42.0315C38.0389 42.4026 37.6678 42.8713 37.4334 43.0862C37.0428 43.4182 36.1053 43.926 35.5194 44.1213C35.3631 44.1604 35.3241 44.2971 35.3241 44.7073C35.3241 45.1565 35.2655 45.2737 35.0116 45.5276C34.5233 45.9963 33.9373 45.9768 33.5077 45.4885C33.2537 45.2151 33.1952 45.0393 33.1952 44.6096V44.0823L32.6678 43.9065C30.6952 43.2424 29.1912 40.5666 30.2459 39.5705C30.8514 38.9846 31.8084 39.2776 32.0233 40.1174C32.2186 40.8987 32.5116 41.3088 33.0389 41.6604C33.5077 41.9533 33.6444 41.9729 34.4256 41.9729C35.3827 41.9729 35.8514 41.7971 36.242 41.2502C36.535 40.8596 36.535 39.8244 36.2616 39.4143C35.9686 38.9651 35.1873 38.5354 33.8983 38.1252C32.3358 37.6174 31.5741 37.2073 30.9295 36.5041C30.2264 35.7229 29.9334 34.9416 29.9139 33.8479C29.8944 32.7932 30.2264 32.0119 30.9686 31.2893C31.4569 30.801 32.6092 30.1565 32.9803 30.1565C33.1366 30.1565 33.1756 30.0783 33.1756 29.6096C33.1756 29.1213 33.2147 29.0237 33.5467 28.6916C33.9569 28.301 34.328 28.2229 34.7381 28.4377Z"
      fill={fillColor}
    />
  </svg>
);

export const RankingIcon = ({
  fillColor = "var(--color-icon-bright)",
  className,
}: {
  fillColor?: string;
  className?: string;
}) => (
  <svg
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    className={className}
  >
    <path
      d="M14.3957 29.168H8.83317C6.5415 29.168 4.6665 31.043 4.6665 33.3346V43.7513C4.6665 44.8971 5.604 45.8346 6.74984 45.8346H14.3957C15.5415 45.8346 16.479 44.8971 16.479 43.7513V31.2513C16.479 30.1055 15.5415 29.168 14.3957 29.168Z"
      fill={fillColor}
    />
    <path
      d="M28.2707 20.832H22.7082C20.4165 20.832 18.5415 22.707 18.5415 24.9987V43.7487C18.5415 44.8945 19.479 45.832 20.6248 45.832H30.354C31.4998 45.832 32.4373 44.8945 32.4373 43.7487V24.9987C32.4373 22.707 30.5832 20.832 28.2707 20.832Z"
      fill={fillColor}
    />
    <path
      d="M42.1668 35.418H36.6043C35.4585 35.418 34.521 36.3555 34.521 37.5013V43.7513C34.521 44.8971 35.4585 45.8346 36.6043 45.8346H44.2502C45.396 45.8346 46.3335 44.8971 46.3335 43.7513V39.5846C46.3335 37.293 44.4585 35.418 42.1668 35.418Z"
      fill={fillColor}
    />
    <path
      d="M31.7707 10.1029C32.4165 9.45703 32.6665 8.6862 32.4582 8.01953C32.2498 7.35286 31.604 6.8737 30.6873 6.72786L28.6873 6.39453C28.604 6.39453 28.4165 6.2487 28.3748 6.16536L27.2707 3.95703C26.4373 2.26953 24.5415 2.26953 23.7082 3.95703L22.604 6.16536C22.5832 6.2487 22.3957 6.39453 22.3123 6.39453L20.3123 6.72786C19.3957 6.8737 18.7707 7.35286 18.5415 8.01953C18.3332 8.6862 18.5832 9.45703 19.229 10.1029L20.7707 11.6654C20.854 11.7279 20.9165 11.9779 20.8957 12.0612L20.4582 13.9779C20.1248 15.4154 20.6665 16.0612 21.0207 16.3112C21.3748 16.5612 22.1457 16.8945 23.4165 16.1445L25.2915 15.0404C25.3748 14.9779 25.6457 14.9779 25.729 15.0404L27.5832 16.1445C28.1665 16.4987 28.6457 16.6029 29.0207 16.6029C29.4582 16.6029 29.7707 16.4362 29.9582 16.3112C30.3123 16.0612 30.854 15.4154 30.5207 13.9779L30.0832 12.0612C30.0623 11.957 30.1248 11.7279 30.2082 11.6654L31.7707 10.1029Z"
      fill={fillColor}
    />
  </svg>
);

export const InfoIcon = ({
  stroke = "var(--color-stroke-active)",
  className,
  ...props
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke={stroke}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 12.835c1.61 0 3.069-.653 4.125-1.709a5.815 5.815 0 0 0 1.708-4.125c0-1.61-.653-3.069-1.708-4.124A5.815 5.815 0 0 0 7 1.168c-1.611 0-3.07.653-4.125 1.709A5.815 5.815 0 0 0 1.167 7c0 1.611.652 3.07 1.708 4.125A5.815 5.815 0 0 0 7 12.835Z"
    />
    <path
      fill={stroke}
      fillRule="evenodd"
      d="M7 4.724a.73.73 0 1 0 0-1.458.73.73 0 0 0 0 1.458Z"
      clipRule="evenodd"
    />
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 5.832v4.667"
    />
  </svg>
);

export const AddCircleIconBlue = ({
  stroke = "var(--color-btn-primary-active)",
  className,
  onclick,
  size = "22"
}: {
  stroke?: string;
  className?: string;
  onclick?: () => void;
  size?:string
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    className={className}
    onClick={onclick}
  >
    <path
      d="M11.0002 20.1654C16.0418 20.1654 20.1668 16.0404 20.1668 10.9987C20.1668 5.95703 16.0418 1.83203 11.0002 1.83203C5.9585 1.83203 1.8335 5.95703 1.8335 10.9987C1.8335 16.0404 5.9585 20.1654 11.0002 20.1654Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.3335 11H14.6668"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 14.6654V7.33203"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const DeleteIcon = ({
  fillColor = "var(--color-icon-bright)",
  className,
  _className = "",
  onclick,
}: {
  fillColor?: string;
  className?: string;
  _className?: string;
  onclick?: () => void;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    onClick={onclick}
  >
    <path
      className={_className}
      d="M2.48194 4.85701L2.48217 4.85699L4.18217 4.69032L4.18388 4.69015C8.57181 4.24476 13.0273 4.41706 17.5095 4.85698L17.5098 4.85701C17.5727 4.86314 17.626 4.92333 17.6191 4.99416L17.619 4.99415L17.6182 5.00435C17.614 5.05932 17.5651 5.10937 17.5001 5.10937H17.5H17.4999H17.4998H17.4997H17.4996H17.4995H17.4994H17.4993H17.4992H17.4991H17.499H17.4989H17.4988H17.4987H17.4986H17.4985H17.4984H17.4983H17.4982H17.4981H17.498H17.4979H17.4978H17.4977H17.4976H17.4974H17.4973H17.4972H17.4971H17.497H17.4969H17.4968H17.4967H17.4966H17.4965H17.4964H17.4963H17.4962H17.4961H17.496H17.4959H17.4958H17.4957H17.4956H17.4955H17.4954H17.4953H17.4952H17.495H17.4949H17.4948H17.4947H17.4946H17.4945H17.4944H17.4943H17.4942H17.4941H17.494H17.4939H17.4938H17.4936H17.4935H17.4934H17.4933H17.4932H17.4931H17.493H17.4929H17.4928H17.4927H17.4925H17.4924H17.4923H17.4922H17.4921H17.492H17.4919H17.4918H17.4917H17.4915H17.4914H17.4913H17.4912H17.4911H17.491H17.4909H17.4908H17.4906H17.4905H17.4904H17.4903H17.4902H17.4901H17.49H17.4899H17.4897H17.4896H17.4895H17.4894H17.4893H17.4892H17.489H17.4889H17.4888H17.4887H17.4886H17.4885H17.4884H17.4882H17.4881H17.488H17.4879H17.4878H17.4877H17.4875H17.4874H17.4873H17.4872H17.4871H17.4869H17.4868H17.4867H17.4866H17.4865H17.4864H17.4862H17.4861H17.486H17.4859H17.4858H17.4856H17.4855H17.4854H17.4853H17.4852H17.485H17.4849H17.4848H17.4847H17.4846H17.4844H17.4843H17.4842H17.4841H17.484H17.4838H17.4837H17.4836H17.4835H17.4833H17.4832H17.4831H17.483H17.4829H17.4827H17.4826H17.4825H17.4824H17.4822H17.4821H17.482H17.4819H17.4817H17.4816H17.4815H17.4814H17.4812H17.4811H17.481H17.4809H17.4808H17.4806H17.4805H17.4804H17.4802H17.4801H17.48H17.4799H17.4797H17.4796H17.4795H17.4794H17.4792H17.4791H17.479H17.4789H17.4787H17.4786H17.4785H17.4784H17.4782H17.4781H17.478H17.4778H17.4777H17.4776H17.4775H17.4773H17.4772H17.4771H17.4769H17.4768H17.4767H17.4766H17.4764H17.4763H17.4762H17.476H17.4759H17.4758H17.4757H17.4755H17.4754H17.4753H17.4751H17.475H17.4749H17.4747H17.4746H17.4745H17.4744H17.4742H17.4741H17.474H17.4738H17.4737H17.4736H17.4734H17.4733H17.4732H17.473H17.4729H17.4728H17.4726H17.4725H17.4724H17.4722H17.4721H17.472H17.4718H17.4717H17.4716H17.4714H17.4713H17.4712H17.471H17.4709H17.4708H17.4706H17.4705H17.4704H17.4702H17.4701H17.47H17.4698H17.4697H17.4696H17.4694H17.4693H17.4692H17.469H17.4689H17.4688H17.4686H17.4685H17.4684H17.4682H17.4681H17.468H17.4678H17.4677H17.4675H17.4674H17.4673H17.4671H17.467H17.4669H17.4667H17.4666H17.4665H17.4663H17.4662H17.466H17.4659H17.4658H17.4656H17.4655H17.4654H17.4652H17.4651H17.465H17.4648H17.4647H17.4645H17.4644H17.4643H17.4641H17.464H17.4638H17.4637H17.4636H17.4634H17.4633H17.4632H17.463H17.4629H17.4627H17.4626H17.4625H17.4623H17.4622H17.462H17.4619H17.4618H17.4616H17.4615H17.4614H17.4612H17.4611H17.4609H17.4608H17.4607H17.4605H17.4604H17.4602H17.4601H17.46H17.4598H17.4597H17.4595H17.4594H17.4593H17.4591H17.459H17.4588H17.4587H17.4585H17.4584H17.4583C13.0395 4.66768 8.61203 4.49987 4.21712 4.94517C4.21685 4.9452 4.21658 4.94523 4.21631 4.94525L2.51931 5.11162C2.51916 5.11164 2.51901 5.11165 2.51886 5.11167C2.4387 5.11908 2.37944 5.06501 2.3728 4.9953C2.36549 4.91857 2.41584 4.86346 2.48194 4.85701Z"
      fill={fillColor}
      stroke={fillColor}
    />
    <path
      className={_className}
      d="M7.0657 4.2679C7.0656 4.2679 7.06551 4.26789 7.06541 4.26789L7.06099 4.26712C7.03187 4.26202 7.0024 4.24438 6.98107 4.21443C6.95997 4.18479 6.95459 4.15428 6.95899 4.12916L6.95957 4.12578L7.1429 3.03411L7.143 3.0335C7.21306 2.61316 7.27999 2.27055 7.48949 2.0117C7.67116 1.78726 8.03594 1.54297 8.90814 1.54297H11.0915C11.9626 1.54297 12.33 1.79437 12.5139 2.02524C12.7255 2.29101 12.7907 2.6379 12.8563 3.04009L12.8563 3.0401L12.8568 3.04306L13.0401 4.1264L13.0403 4.12712C13.046 4.16053 13.0379 4.19353 13.0185 4.22068C12.9991 4.248 12.9741 4.26165 12.9506 4.26517L12.9506 4.26507L12.9407 4.26677C12.9072 4.27247 12.8742 4.26437 12.8471 4.24504C12.8198 4.22559 12.8061 4.2006 12.8026 4.17713L12.8027 4.17712L12.8011 4.16787L12.6181 3.08657L12.6158 3.07225C12.5891 2.90623 12.5617 2.73534 12.5208 2.59077C12.477 2.43554 12.4031 2.25284 12.2461 2.10212C12.0864 1.94876 11.8938 1.87888 11.7103 1.84371C11.5331 1.80972 11.3264 1.8013 11.0998 1.8013H8.91647C8.69269 1.8013 8.48841 1.80803 8.3144 1.83872C8.13479 1.87039 7.9404 1.93521 7.77792 2.0873C7.6178 2.23717 7.54346 2.42109 7.4994 2.5752C7.45903 2.71642 7.43063 2.8852 7.40265 3.05142C7.40136 3.05913 7.40006 3.06684 7.39876 3.07454L7.20745 4.15586L7.2074 4.15585L7.20625 4.16293C7.19643 4.22352 7.14367 4.26797 7.08314 4.26797L7.0657 4.2679Z"
      fill={fillColor}
      stroke={fillColor}
    />
    <path
      className={_className}
      d="M4.16563 7.62741L4.16564 7.62741L4.16533 7.62313C4.16329 7.59522 4.17242 7.56488 4.19632 7.5377C4.21915 7.51173 4.24928 7.496 4.28055 7.4922C4.3595 7.49157 4.41249 7.54673 4.41789 7.61143L4.95937 16.0002L4.95935 16.0002L4.95963 16.004L4.96132 16.0274C4.98291 16.3259 5.00402 16.6179 5.05291 16.8698C5.10412 17.1335 5.19483 17.4077 5.39329 17.6392C5.79414 18.1068 6.46409 18.2096 7.325 18.2096H12.675C13.5391 18.2096 14.2118 18.1072 14.613 17.6392C14.812 17.4069 14.9021 17.1319 14.9522 16.8675C15.0003 16.6137 15.0196 16.3195 15.0394 16.019L15.0406 16.0008L15.0406 16.0002L15.5821 7.61151C15.5873 7.55013 15.6449 7.49168 15.7196 7.49219C15.7942 7.50068 15.839 7.56229 15.8346 7.62399L15.8344 7.62741L15.2929 16.0161C15.2929 16.0166 15.2928 16.0171 15.2928 16.0176C15.2449 16.6963 15.1906 17.2722 14.883 17.7019C14.6082 18.0858 14.0403 18.4596 12.675 18.4596H7.325C5.9597 18.4596 5.39182 18.0858 5.11698 17.7019C4.80935 17.2722 4.75507 16.6963 4.7072 16.0176C4.70716 16.0171 4.70713 16.0166 4.70709 16.0161L4.16563 7.62741Z"
      fill={fillColor}
      stroke={fillColor}
    />
    <path
      className={_className}
      d="M11.3834 13.875H8.6084C8.57825 13.875 8.54697 13.8627 8.52133 13.8371C8.49568 13.8114 8.4834 13.7801 8.4834 13.75C8.4834 13.7199 8.49568 13.6886 8.52133 13.6629C8.54697 13.6373 8.57825 13.625 8.6084 13.625H11.3834C11.4135 13.625 11.4448 13.6373 11.4705 13.6629C11.4961 13.6886 11.5084 13.7199 11.5084 13.75C11.5084 13.7801 11.4961 13.8114 11.4705 13.8371C11.4448 13.8627 11.4135 13.875 11.3834 13.875Z"
      fill={fillColor}
      stroke={fillColor}
    />
    <path
      className={_className}
      d="M12.0832 10.543H7.9165C7.88636 10.543 7.85508 10.5307 7.82943 10.505C7.80379 10.4794 7.7915 10.4481 7.7915 10.418C7.7915 10.3878 7.80379 10.3565 7.82943 10.3309C7.85508 10.3053 7.88636 10.293 7.9165 10.293H12.0832C12.1133 10.293 12.1446 10.3053 12.1702 10.3309C12.1959 10.3565 12.2082 10.3878 12.2082 10.418C12.2082 10.4481 12.1959 10.4794 12.1702 10.505C12.1446 10.5307 12.1133 10.543 12.0832 10.543Z"
      fill={fillColor}
      stroke={fillColor}
    />
  </svg>
);

export const EyeIconBlue = ({
  stroke = "var(--color-stroke-active)",
  className,
}: {
  stroke?: string;
  className?: string;
}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M12.9833 9.99896C12.9833 11.649 11.6499 12.9823 9.99993 12.9823C8.34993 12.9823 7.0166 11.649 7.0166 9.99896C7.0166 8.34896 8.34993 7.01562 9.99993 7.01562C11.6499 7.01562 12.9833 8.34896 12.9833 9.99896Z"
      stroke="var(--color-blue)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99987 16.8932C12.9415 16.8932 15.6832 15.1599 17.5915 12.1599C18.3415 10.9849 18.3415 9.0099 17.5915 7.8349C15.6832 4.8349 12.9415 3.10156 9.99987 3.10156C7.0582 3.10156 4.31654 4.8349 2.4082 7.8349C1.6582 9.0099 1.6582 10.9849 2.4082 12.1599C4.31654 15.1599 7.0582 16.8932 9.99987 16.8932Z"
      stroke="var(--color-blue)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MoreIconActive: React.FC<IconProps> = ({ ...props }: any) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" {...props}>
    <path
      d="M12.2918 16.3333C12.2918 17.6 11.2668 18.625 10.0002 18.625C8.7335 18.625 7.7085 17.6 7.7085 16.3333C7.7085 15.0667 8.7335 14.0417 10.0002 14.0417C11.2668 14.0417 12.2918 15.0667 12.2918 16.3333ZM8.9585 16.3333C8.9585 16.9083 9.42516 17.375 10.0002 17.375C10.5752 17.375 11.0418 16.9083 11.0418 16.3333C11.0418 15.7583 10.5752 15.2917 10.0002 15.2917C9.42516 15.2917 8.9585 15.7583 8.9585 16.3333Z"
      fill="var(--color-icon-obscure)"
    />
    <path
      d="M12.2918 4.66671C12.2918 5.93337 11.2668 6.95837 10.0002 6.95837C8.7335 6.95837 7.7085 5.93337 7.7085 4.66671C7.7085 3.40004 8.7335 2.37504 10.0002 2.37504C11.2668 2.37504 12.2918 3.40004 12.2918 4.66671ZM8.9585 4.66671C8.9585 5.24171 9.42516 5.70837 10.0002 5.70837C10.5752 5.70837 11.0418 5.24171 11.0418 4.66671C11.0418 4.09171 10.5752 3.62504 10.0002 3.62504C9.42516 3.62504 8.9585 4.09171 8.9585 4.66671Z"
      fill="var(--color-icon-obscure)"
    />
    <path
      d="M12.2918 10.5C12.2918 11.7666 11.2668 12.7916 10.0002 12.7916C8.7335 12.7916 7.7085 11.7666 7.7085 10.5C7.7085 9.23329 8.7335 8.20829 10.0002 8.20829C11.2668 8.20829 12.2918 9.23329 12.2918 10.5ZM8.9585 10.5C8.9585 11.075 9.42516 11.5416 10.0002 11.5416C10.5752 11.5416 11.0418 11.075 11.0418 10.5C11.0418 9.92496 10.5752 9.45829 10.0002 9.45829C9.42516 9.45829 8.9585 9.92496 8.9585 10.5Z"
      fill="var(--color-icon-obscure)"
    />
  </svg>
);

export const PlanNoDataIcon: React.FC<IconProps> = ({ ...props }: any) => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" {...props}>
    <path
      d="M34.9997 66.3542C32.7247 66.3542 30.508 65.1875 28.9913 63.1459L26.0455 59.2084C25.433 58.3917 24.6163 57.925 23.7413 57.8667C22.8663 57.8375 21.9913 58.2167 21.2913 58.9459L19.6288 57.4584L21.233 58.9459C17.033 63.4375 13.7955 63.0875 12.2497 62.475C10.6747 61.8625 8.02051 59.85 8.02051 53.375V20.5334C8.02051 7.58337 11.7538 3.64587 23.9747 3.64587H46.0247C58.2455 3.64587 61.9788 7.58337 61.9788 20.5334V53.375C61.9788 59.8209 59.3247 61.8334 57.7497 62.475C56.2038 63.0875 52.9955 63.4375 48.7663 58.9459C48.0663 58.1875 47.1913 57.7792 46.2872 57.8667C45.4122 57.925 44.5663 58.3917 43.9538 59.2084L41.008 63.1459C39.4913 65.1875 37.2747 66.3542 34.9997 66.3542ZM23.5663 53.4625C23.683 53.4625 23.8288 53.4625 23.9455 53.4625C26.1038 53.5792 28.1455 54.7167 29.5163 56.5542L32.4622 60.4917C33.8913 62.3875 36.0788 62.3875 37.508 60.4917L40.4538 56.5542C41.8538 54.7167 43.8663 53.5792 46.0538 53.4625C48.2122 53.3459 50.3705 54.25 51.9455 55.9417C54.1622 58.3042 55.5913 58.5959 56.1163 58.3917C56.8163 58.1 57.5747 56.4084 57.5747 53.375V20.5334C57.5747 10.0042 55.7372 8.02087 45.9955 8.02087H23.9747C14.233 8.02087 12.3955 10.0042 12.3955 20.5334V53.375C12.3955 56.4375 13.1538 58.1292 13.8538 58.3917C14.3497 58.5959 15.808 58.3042 18.0247 55.9417C19.5997 54.3375 21.5538 53.4625 23.5663 53.4625Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M47.3376 34.2709H31.2959C30.1001 34.2709 29.1084 33.2792 29.1084 32.0834C29.1084 30.8875 30.1001 29.8959 31.2959 29.8959H47.3376C48.5334 29.8959 49.5251 30.8875 49.5251 32.0834C49.5251 33.2792 48.5334 34.2709 47.3376 34.2709Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M47.3376 22.6041H31.2959C30.1001 22.6041 29.1084 21.6125 29.1084 20.4166C29.1084 19.2208 30.1001 18.2291 31.2959 18.2291H47.3376C48.5334 18.2291 49.5251 19.2208 49.5251 20.4166C49.5251 21.6125 48.5334 22.6041 47.3376 22.6041Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M22.6921 23.3333C21.0879 23.3333 19.7754 22.0208 19.7754 20.4167C19.7754 18.8125 21.0879 17.5 22.6921 17.5C24.2962 17.5 25.6087 18.8125 25.6087 20.4167C25.6087 22.0208 24.2962 23.3333 22.6921 23.3333Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M22.6921 35C21.0879 35 19.7754 33.6875 19.7754 32.0833C19.7754 30.4791 21.0879 29.1666 22.6921 29.1666C24.2962 29.1666 25.6087 30.4791 25.6087 32.0833C25.6087 33.6875 24.2962 35 22.6921 35Z"
      fill="var(--color-stroke-active)"
    />
  </svg>
);

export const NoPaymentsIcon: React.FC<IconProps> = ({ ...props }) => (
  <svg width="71" height="70" viewBox="0 0 71 70" fill="none" {...props}>
    <path
      d="M52.2413 66.3541H22.7829C21.8788 66.3541 21.0621 65.8 20.7413 64.925C20.4204 64.05 20.6537 63.1166 21.3537 62.5041C23.3954 60.6958 24.5912 58.0999 24.5912 55.3874C24.5912 50.1666 20.3329 45.9083 15.1121 45.9083C12.9537 45.9083 10.9121 46.6375 9.19125 48.0084C8.52042 48.5334 7.64544 48.6208 6.8871 48.2708C6.12877 47.9208 5.66211 47.1333 5.66211 46.2875V33.5416C5.66211 26.2791 11.5538 20.3875 18.8163 20.3875H52.2996C59.5621 20.3875 65.4538 26.2791 65.4538 33.5416V37.7417C65.4538 38.9375 64.4621 39.9292 63.2663 39.9292H57.3746C56.3538 39.9292 55.4204 40.3083 54.7496 41.0083L54.7204 41.0375C53.9038 41.825 53.5246 42.9042 53.6121 44.0126C53.7871 45.9376 55.6246 47.4834 57.7246 47.4834H63.2663C64.4621 47.4834 65.4538 48.4751 65.4538 49.6709V53.1416C65.3954 60.4624 59.5038 66.3541 52.2413 66.3541ZM27.2746 61.9791H52.2413C57.0829 61.9791 61.0204 58.0416 61.0204 53.1999V51.9166H57.6663C53.2621 51.9166 49.5288 48.6499 49.1788 44.4499C48.9454 42.0583 49.8204 39.6959 51.5704 37.975C53.0871 36.4292 55.1288 35.5833 57.3163 35.5833H61.0204V33.5708C61.0204 28.7292 57.0829 24.7916 52.2413 24.7916H18.7579C13.9162 24.7916 9.97876 28.7292 9.97876 33.5708V42.5542C11.6121 41.9126 13.3329 41.5625 15.0829 41.5625C22.7246 41.5625 28.9371 47.775 28.9371 55.4166C28.9371 57.7208 28.3537 59.9958 27.2746 61.9791Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M7.79199 35.7587C6.59616 35.7587 5.60449 34.767 5.60449 33.5712V22.867C5.60449 18.5212 8.31701 14.5544 12.3712 13.0377L35.5295 4.28771C37.9211 3.41271 40.6045 3.73372 42.6753 5.19205C44.7462 6.65038 46.0003 9.01283 46.0003 11.5212V22.6045C46.0003 23.8003 45.0087 24.792 43.8128 24.792C42.617 24.792 41.6253 23.8003 41.6253 22.6045V11.5212C41.6253 10.4128 41.1003 9.42116 40.1962 8.77949C39.2628 8.13783 38.1253 7.99195 37.0753 8.37112L13.917 17.1211C11.5253 18.0253 9.97949 20.2712 9.97949 22.867V33.5712C9.97949 34.767 8.98783 35.7587 7.79199 35.7587Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M57.6662 51.9165C53.2621 51.9165 49.5287 48.6499 49.1787 44.4499C48.9454 42.029 49.8204 39.6666 51.5704 37.9457C53.0579 36.4291 55.0996 35.5833 57.2871 35.5833H63.3537C66.2412 35.6708 68.4579 37.9456 68.4579 40.7456V46.7541C68.4579 49.5541 66.2412 51.829 63.4412 51.9165H57.6662ZM63.2954 39.9583H57.3162C56.2954 39.9583 55.3621 40.3374 54.6912 41.0374C53.8454 41.8541 53.4371 42.9623 53.5537 44.0707C53.7287 45.9957 55.5662 47.5415 57.6662 47.5415H63.3829C63.762 47.5415 64.112 47.1916 64.112 46.7541V40.7456C64.112 40.3081 63.762 39.9874 63.2954 39.9583Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M41.3337 37.1875H20.917C19.7212 37.1875 18.7295 36.1958 18.7295 35C18.7295 33.8042 19.7212 32.8125 20.917 32.8125H41.3337C42.5295 32.8125 43.5212 33.8042 43.5212 35C43.5212 36.1958 42.5295 37.1875 41.3337 37.1875Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M15.0837 69.2708C7.44199 69.2708 1.22949 63.0583 1.22949 55.4167C1.22949 51.1583 3.12532 47.2208 6.42116 44.5958C8.87116 42.6416 11.9628 41.5625 15.0837 41.5625C22.7253 41.5625 28.9378 47.775 28.9378 55.4167C28.9378 59.3833 27.217 63.175 24.242 65.8C21.6753 68.0458 18.4378 69.2708 15.0837 69.2708ZM15.0837 45.9375C12.9253 45.9375 10.8837 46.6666 9.16283 48.0374C6.917 49.8166 5.60449 52.5292 5.60449 55.4167C5.60449 60.6375 9.86283 64.8958 15.0837 64.8958C17.3587 64.8958 19.5753 64.05 21.3545 62.5333C23.3961 60.725 24.5628 58.1583 24.5628 55.4167C24.5628 50.1958 20.3045 45.9375 15.0837 45.9375Z"
      fill="var(--color-stroke-active)"
    />
    <path
      d="M12.166 60.5209C11.4368 60.5209 10.7077 60.1418 10.2993 59.4709C9.68684 58.4209 10.0077 57.0792 11.0577 56.4667L13.6535 54.9209V51.7709C13.6535 50.575 14.6452 49.5834 15.841 49.5834C17.0368 49.5834 18.0285 50.575 18.0285 51.7709V56.1459C18.0285 56.9042 17.6201 57.6334 16.9785 58.0126L13.3326 60.2001C12.9535 60.4334 12.5452 60.5209 12.166 60.5209Z"
      fill="var(--color-stroke-active)"
    />
  </svg>
);
